export default "__VITE_ASSET__4cf6626f__"